// Tracks the previous in-app route so the 404 page can report WHERE a broken
// link was clicked from. `document.referrer` is insufficient for a SPA: it only
// reflects the full-page entry referrer and never updates on client-side route
// changes, so an internal bad link would show a stale/blank referrer. Layout
// records each navigation during render (a parent renders before its route
// element), so `getPreviousPath()` is already set by the time the 404 page's
// effect reads it.

let currentPath: string | null = null
let previousPath: string | null = null

/** Advance the history by one route. No-op if the path hasn't changed (guards
 *  StrictMode's double render and incidental re-renders). */
export function recordNavigation(pathname: string): void {
  if (pathname === currentPath) return
  previousPath = currentPath
  currentPath = pathname
}

/** The route the user was on before the current one, or null on first load /
 *  direct entry (no prior in-app route). */
export function getPreviousPath(): string | null {
  return previousPath
}
